<div class="flex-col" id="user-info">
    @if (authService.isAuthenticated) {
        <div class="details flex-row">
            <div class="flex-col">
                <span class="mat-headline-6">{{ currentUser.profile.name }}</span>
                <span class="mat-body-strong">{{ currentUser.userName }}</span>
            </div>
        </div>
    }
    @if (authService.isAuthenticated) {
        <div class="flex-row">
            <button mat-raised-button matTooltip="Logout" (click)="authService.logout()">
                Logout
            </button>
            <span class="flex"></span>
            <button mat-icon-button matTooltip="Settings" (click)="navigateToUserSettings($event)">
                <mat-icon>settings</mat-icon>
            </button>
        </div>
    }
    @if (!authService.isAuthenticated) {
        <span class="mat-subhead">Please log on</span>
    }
</div>
